import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge Tailwind classes; a later class wins over an earlier one in the same property group. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
